import { Router } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { UtilsService } from './../../providers/utils/utils.service';
import { CustomError } from './../../models/custom-error';
import { ToasterService } from 'angular2-toaster';
import { configuration } from './../../configuration';
import { AuthService } from '@pluritech/auth-service';
import { Credential } from './../../models/credential';
import { LoginService } from './../../providers/login/login.service';
import { AuthenticationService } from './../../_services';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {

  private classes = ['hold-transition', 'login-page'];
  public projectName = configuration.projectName;
  public logoDefault: string = configuration.logoDefaultImage;
  public logosmall: string = configuration.logosmallImage;
  public isFormSubmitted: boolean;
  public loginForm: FormGroup;
  public errorMsg: string;
  returnUrl: string;
  loading = false;
  submitted = false;
  error = '';
  role ='';
  massage="";
  
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private loginService: LoginService,
    private authService: AuthService,
    private toasterService: ToasterService,
    private utilsService: UtilsService,
    private authservice: AuthenticationService
  ) {}

  private initForm(): void {
  this.loginForm = this.formBuilder.group({
  username: ['', Validators.required],
  password: ['', Validators.required]
});
}

 
get f() { return this.loginForm.controls; }

onSubmit() 
{

  this.submitted = true;
  //this.submitted = true;
  // stop here if form is invalid
  if (this.loginForm.invalid) {
      return;
  }
  //this.loading = true;
  this.authservice.login(this.f.username.value, this.f.password.value)
       .subscribe(
       data => {
           
        console.log("data login",data);
             if(data.Data)
             {
           console.log("data",data)
              this.massage=data.Metadata.Message
              this.router.navigate(['/']);
             }
             else
             {
this.massage=data.Metadata.Message
             }
            },
          error => {
              console.log("error",error);
            });


      }


  ngOnInit() {
    this.initForm();
    const body = document.getElementsByTagName('body')[0];
    for (const cl of this.classes) {
      body.classList.add(cl);
    }
  }

  ngOnDestroy() {
    const body = document.getElementsByTagName('body')[0];
    for (const cl of this.classes) {
      body.classList.remove(cl);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/login/login.component.ts